import { AbstractHook } from '@hooks/abstraction';
import { CompanyService } from '../services/company.service';
import { CompanyResponse } from '../services/responses/company.response';

export class CompanyHook extends AbstractHook<CompanyResponse, CompanyService> {}
